import React, { useState } from 'react'
import AccountingFirms from '../../../components/purchaseInvoices/accounting/accountingFirms'
import AllocationKeys from '../../../components/purchaseInvoices/allocation/AllocationKeys'
import UserRoles from '../../../components/userRoles/userRoles'
import Groups from '../../../components/purchaseInvoices/groups/groups'
import AllocationDateRanges from '../../../components/purchaseInvoices/allocation/AllocationDateRanges'
import AccountManagerDelegations from '../../../components/purchaseInvoices/delegations/accountManagerDelegations'
import GroupManagersTab from '../../../components/purchaseInvoices/settings/GroupManagersTab'
import { Box, Tabs, Tab } from '@mui/material'
import { useResponsive } from '../../../hooks/purchaseInvoices/useResponsive.js'

const Setting = () => {
  const [activeTab, setActiveTab] = useState(0)
  const { isDesktop } = useResponsive()

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue)
  }

  return (
    <div>
      <Box sx={{ 
        borderBottom: 1, 
        borderColor: 'divider', 
        mb: { xs: 3, md: 2 }
      }}>
        <Tabs 
          value={activeTab} 
          onChange={handleTabChange}
          dir="rtl"
          variant={isDesktop ? 'standard' : 'scrollable'}
          scrollButtons="auto"
          allowScrollButtonsMobile
          sx={{ 
            '& .MuiTabs-flexContainer': { 
              justifyContent: 'flex-start'
            },
            '& .MuiTab-root': {
              fontSize: { xs: '0.8rem', md: '0.875rem' },
              fontWeight: { xs: 600, md: 'inherit' },
              px: { xs: 1.5, md: 2 },
              py: { xs: 2, md: 'inherit' },
              minWidth: { xs: 100, md: 'auto' },
              maxWidth: { xs: 180, md: 'none' }
            }
          }}
        >
          <Tab label="חברות" />
          <Tab label="מפתחות העמסה" />
          <Tab label="תפקידים" />
          <Tab label="קבוצות" />
          <Tab label="טווחי הקצאה" />
          <Tab label="הסבות מנהלות חשבונות" />
          <Tab label="מנהלי קבוצות" />
        </Tabs>
      </Box>

      <Box sx={{ 
        px: { xs: 2, md: 0 },
        pb: { xs: 2, md: 0 }
      }}>
        {activeTab === 0 && <AccountingFirms />}
        {activeTab === 1 && <AllocationKeys />}
        {activeTab === 2 && <UserRoles />}
        {activeTab === 3 && <Groups />}
        {activeTab === 4 && <AllocationDateRanges />}
        {activeTab === 5 && <AccountManagerDelegations />}
        {activeTab === 6 && <GroupManagersTab />}
      </Box>
    </div>
  )
}

export default Setting
